var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.isLegacyData
      ? _c(
          "div",
          { staticClass: "row" },
          _vm._l(Object.keys(_vm.coverageSummary), function(section, i) {
            return _c("div", { key: i, staticClass: "col-md-12" }, [
              section != "vehicleCoverages"
                ? _c(
                    "div",
                    [
                      _c("div", { staticClass: "section-label" }, [
                        _vm._v(_vm._s(_vm.humanize(section)))
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.coverageSummary[section], function(row, j) {
                        return _c("div", { key: j, staticClass: "row" }, [
                          _c("div", { staticClass: "row-label col-md-6" }, [
                            _vm._v(_vm._s(row.label))
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "row-value col-md-6 text-right" },
                            [_vm._v(_vm._s(row.text))]
                          )
                        ])
                      })
                    ],
                    2
                  )
                : _c(
                    "div",
                    { staticClass: "row" },
                    _vm._l(_vm.coverageSummary[section], function(row, j) {
                      return _c("div", { key: j, staticClass: "col-6" }, [
                        _c(
                          "div",
                          { staticClass: "row no-gutters pt-4" },
                          [
                            _c(
                              "div",
                              { staticClass: "section-label col-md-12" },
                              [_vm._v(_vm._s(row.label))]
                            ),
                            _vm._v(" "),
                            _vm._l(row.coverageDetails, function(childrow, l) {
                              return _c(
                                "div",
                                { key: l, staticClass: "col-md-12" },
                                [
                                  _c("div", { staticClass: "row no-gutters" }, [
                                    _c(
                                      "div",
                                      { staticClass: "row-label col-md-6" },
                                      [
                                        _vm._v(
                                          " " + _vm._s(childrow.label) + " "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "row-value col-md-6 text-right"
                                      },
                                      [_vm._v(_vm._s(childrow.text))]
                                    )
                                  ])
                                ]
                              )
                            })
                          ],
                          2
                        )
                      ])
                    }),
                    0
                  )
            ])
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b13a881", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b13a881","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/interview/shared/AutoCarrierCoverageSummary.vue
// module id = null
// module chunks = 